import jrInlineProposalFormTemplate from '../../view/angular/serp/inline-proposal.tpl.html';
import jrInlineProposalSubscriptionSentTemplate from '../../view/angular/serp/inline-proposal-subscription-sent.tpl.html';

angular
  .module('jrInlineProposal', ['jrConfig', 'jrUtil', 'jrEvents', 'jrAutocompleteEmail'])
  .factory('inlineProposalDataService', [
    'InlineProposalConfig',
    'JobseekerConfig',
    function (InlineProposalConfig, JobseekerConfig) {
      const inlineProposalEnabled =
        !JobseekerConfig.isLogged && !!InlineProposalConfig.advertTypeWithInlineProposal;
      let prevActivatedProposalScope;
      return {
        inlineProposalEnabled,
        storeActivatedProposal(proposalScope) {
          prevActivatedProposalScope = proposalScope;
        },
        deactivatePrevious() {
          if (prevActivatedProposalScope) {
            prevActivatedProposalScope.deactivateProposal();
            prevActivatedProposalScope = undefined;
          }
        },
      };
    },
  ])
  .directive('jrInlineProposalForm', [
    '$rootScope',
    function ($rootScope) {
      return {
        restrict: 'AE',
        replace: true,
        template: jrInlineProposalFormTemplate,
        link(scope, element, attrs) {
          if (scope.captchaEnabled) {
            element.ready(function () {
              const interval = setInterval(() => {
                if (window.grecaptcha) {
                  grecaptcha.ready(() => {
                    $rootScope.inlineProposalCaptcha = grecaptcha.render(
                      `inline-captcha-container-${scope.advert.advertId}`,
                      {
                        sitekey: jrConfigGlobal.captcha.siteKey,
                        size: 'invisible',
                        badge: 'inline',
                        callback: scope.handleCaptchaCallback,
                        'error-callback': scope.handleCaptchaError,
                        'expired-callback': scope.handleCaptchaError,
                      }
                    );
                  });
                  clearInterval(interval);
                }
              }, 100);
            });
          }
        },
      };
    },
  ])
  .directive('jrInlineProposalSubscriptionSent', [
    function () {
      return {
        restrict: 'AE',
        replace: true,
        template: jrInlineProposalSubscriptionSentTemplate,
      };
    },
  ]);
